import React from 'react';
import { useStickyLayout } from '../hooks/useStickyLayout';

type StickyLayoutContainerProps = { children: React.ReactNode };

const StickyLayoutContainer = ({ children }: StickyLayoutContainerProps) => {
	const { blockClass, position, verticalSpacing, zIndex, isStuck } = useStickyLayout();

	const renderStyles = () => {
		if (position) {
			const styles = position === 'top' ? { top: verticalSpacing } : { bottom: verticalSpacing };
			return styles;
		}

		return {};
	};

	return (
		<div
			className={`vtex-sticky-layout-0-x-container
      vtex-sticky-layout-0-x-container--${blockClass} container container--${blockClass}
      ${zIndex ?? 'z-999'} ${isStuck ? 'fixed' : 'relative'}
      left-0
      right-0`}
			style={renderStyles()}
		>
			{children}
		</div>
	);
};

export default StickyLayoutContainer;
